var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgIconCalculation = function SvgIconCalculation(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#b3bccf;stroke:rgba(0,0,0,0);stroke-miterlimit:10;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-8150-8241v-14h-2v-2h2v-3a1,1,0,0,1,1-1,1,1,0,0,1,1,1v3h2v2h-2v14Zm-7,0v-9h-2v-2h2v-8a1,1,0,0,1,1-1,1,1,0,0,1,1,1v8h2v2h-2v9Zm-7,0v-4h-2v-2h2l0-13.03h0a1,1,0,0,1,1-.97,1,1,0,0,1,1,1,1.03,1.03,0,0,1-.006.11L-8162-8247h2v2h-2v4Z",
    transform: "translate(8166 8261)"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconCalculation, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_calculation.d4354ac8.svg";
export { ForwardRef as ReactComponent };